/**
 * Redirects to a given url.
 *
 * @param url
 */
export const redirectTo = (url) => {
    if (!url) {
        return;
    }

    window.location.assign(url);
};
